import { FormSection } from "Components/Shared/FormSection";
import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { PhoneInput } from "Components/Shared/Inputs/Form/PhoneInput";
import { RegistryLinks } from "Components/Shared/RegistryLinks/RegistryLinks";
import { AddressFields } from "Components/Users/UserDetailPageContent/Components/AddressFields";
import type { PartyFormFieldsProps } from "Components/Users/UserDetailPageContent/Components/PartyForm/types";
import { usePartyTypeList } from "Hooks/Options/usePartyTypeList";
import { Resources, useResource } from "Translations/Resources";
import { useWatch } from "react-hook-form";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form.LegalEntity;

export const LegalEntityFields = ({
  control,
  addresses,
}: PartyFormFieldsProps) => {
  const { t } = useResource();
  const partyTypeList = usePartyTypeList({ onlyBusiness: false });
  const companyNumber = useWatch({ control, name: "companyNumber" });

  return (
    <>
      <Dropdown
        codeList={partyTypeList}
        name="type"
        control={control}
        label={t(COMPONENT_RESOURCES.Type)}
        disabled
      />
      <FormSection legend={t(COMPONENT_RESOURCES.Legend.Company)}>
        <FormInput
          control={control}
          name="companyName"
          label={t(COMPONENT_RESOURCES.CompanyName)}
        />
        <FormInput
          control={control}
          name="companyNumber"
          label={t(COMPONENT_RESOURCES.CompanyNumber)}
        />
        <FormInput
          control={control}
          name="taxNumber"
          label={t(COMPONENT_RESOURCES.TaxNumber)}
        />
        <FormInput
          control={control}
          name="vatNumber"
          label={t(Resources.Common.VatNumber)}
        />
        {companyNumber && <RegistryLinks companyNumber={companyNumber} />}
      </FormSection>
      <FormSection legend={t(COMPONENT_RESOURCES.Legend.Contact)}>
        <PhoneInput
          control={control}
          name="phone"
          label={t(COMPONENT_RESOURCES.Phone)}
        />
        <FormInput
          control={control}
          name="email"
          label={t(COMPONENT_RESOURCES.Email)}
          type="email"
          valueTransformer={(v) => v.toLowerCase()}
        />
      </FormSection>
      <AddressFields addresses={addresses} control={control} />
    </>
  );
};
